/**
 * Recursively detects changes between two objects
 * @param {Object} prevObj - The previous object state
 * @param {Object} nextObj - The new object state
 * @param {number} index - The index in the parent array (if applicable)
 * @param {Array} changes - Array to collect all detected changes
 * @param {Array} path - Current path in the object structure
 */
function detectObjectChanges(prevObj, nextObj, index, changes, path) {
  // Get all unique keys from both objects to compare
  const allKeys = new Set([
    ...Object.keys(prevObj || {}),
    ...Object.keys(nextObj || {})
  ]);

  // Iterate through all keys to compare values
  Array.from(allKeys).forEach(key => {
    const prevVal = prevObj ? prevObj[key] : undefined;
    const nextVal = nextObj ? nextObj[key] : undefined;

    // If both values are objects, recursively check for nested changes
    if (typeof prevVal === 'object' && typeof nextVal === 'object' && prevVal && nextVal) {
      detectObjectChanges(prevVal, nextVal, index, changes, [...path, key]);
    } 
    // If values are different, record the change
    else if (JSON.stringify(prevVal) !== JSON.stringify(nextVal)) {
      changes.push({
        index,
        path: [...path, key].join('.'), // Create dot notation path (e.g., "user.address.street")
        prev: prevVal,
        next: nextVal,
      });
    }
  });
}

/**
 * Compares two arrays and detects changes between their elements
 * @param {Array} prev - The previous array to compare
 * @param {Array} next - The new array to compare
 * @returns {Array} An array of changes, where each change contains the index, path, previous value, and new value
 */
function compareArrays(prev, next) {
  const changes = [];

  // Iterate through both arrays using the length of the longer array
  for (let i = 0; i < Math.max(prev.length, next.length); i++) {
    const prevObj = prev[i];
    const nextObj = next[i];

    // Compare objects using JSON.stringify to detect any differences
    if (JSON.stringify(prevObj) !== JSON.stringify(nextObj)) {
      // If differences are found, analyze them in detail using detectObjectChanges
      detectObjectChanges(prevObj, nextObj, i, changes, []);
    }
  }

  return changes;
}

module.exports = {
    compareArrays,
    detectObjectChanges
}